import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'listDetail'
})
export class ListDetailPipe implements PipeTransform {

  transform(items: any[], key: string, value: any): unknown {
    if (!items) {
      return [];
    }
    if (!key) {
      return items;
    }

    return items.filter(ct => {
      return ct[key] == value
    });
    
  }

}
